import script from "./V4NoteEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./V4NoteEntry.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__